import React, {Component, Fragment} from 'react';
import { Link } from 'react-router-dom';
import ResponsiveTable from 'Components/ResponsiveTable';
import Checkbox from 'Components/Checkbox/index';
import TransportersTableHeader from 'Components/TransportersTableHeader/index';
import { LOG_IN_AND_LOG_OUT, HIKAL } from '../../constants/commonConstants';

import TimePicker from 'rc-time-picker';
import moment from 'moment';
import { SingleDatePicker }  from 'react-dates';
import { getUser } from 'Utils/storage';

class TransportersTable extends Component {
    state = {
        selectedTransporters: [],
        focused: null,
        date: new Date(),
    };
    render() {
        const { 
            transporters, 
            rfqId,
            offset,
            transportersCount,
            rfqType
        } = this.props;
        return (
            <div>
                <div className="box-shadow mr-15 ml-15 ph-60 pv-20 mb-20 br-5 mb-20">
                    <TransportersTableHeader 
                        offset={offset || 0}
                        transportersCount={transportersCount || 100}
                        showCreateGroupPopup = {this.showCreateGroupPopup}
                        fetchTransporters={this.props.fetchTransporters}
                        viewMode = {true}
                        header={"Recipients"}
                        searchPlaceholder={HIKAL.includes(getUser().companyId) ? 'Search Service Provider' : ([9].includes(rfqType) ? 'Search Buyers' : '')}
                    />
                    <ResponsiveTable >
                        {
                            (transporters || []).map((transporter, index)=> {
                                return(
                                <Fragment key={(index + 1)}>
                                    {index === 0 && <div className="flex flex-middle mb-20 ">
                                        <div className="fBold fs-16 header-dark-color wt-150">Recipients</div>
                                        <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Bids</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Message</div>
                                        <div className="fBold fs-16 header-dark-color wt-200 pl-15">Seen Status</div>
                                        <div className="fBold fs-16 header-dark-color wt-200 pl-15">RFQ Seen Date Time</div>
                                        <div className="fBold fs-16 header-dark-color wt-200 pl-15">Branch</div>
                                        <div className="fBold fs-16 header-dark-color wt-200 pl-15">Log In Time</div>
                                        <div className="fBold fs-16 header-dark-color wt-200 pl-15">Log Out Time</div>
                                        {/* <div className="fBold fs-16 header-dark-color wt-200 pl-15">Change Bid Time</div> */}
                                    </div>}
                                    <Link to={`/seeker/bids/transporters/detail/${rfqId}/${transporter.id}`} className="fSemibold flex flex-middle border-top-light pt-25 pb-25 pr col-1">
                                        <div className="fs-14 table-text-color wt-150">{transporter.name}</div>
                                        <div className="fs-12 fSemibold table-text-color wt-150 pl-15">
                                            {!transporter.isBids && <div className="error-color mb-3">No Bid</div>}
                                            {transporter.isBids && <div className="table-text-color mb-3">Bid</div>}
                                            {transporter.isPartial && <div className="caption-color">Partial Solution</div>}
                                            {!transporter.isPartial && <div className="caption-color">Complete Solution</div>}
                                        </div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{transporter.message}</div>
                                        <div className="fs-14 table-text-color wt-200 pl-15">{transporter.seenStatus}</div>
                                        <div className="fs-14 table-text-color wt-200 pl-15">{transporter.is_seen_date && moment(transporter.is_seen_date).format(LOG_IN_AND_LOG_OUT) }</div>
                                        <div className="fs-14 table-text-color wt-200 pl-15">{transporter.branchName}</div>
                                        <div className="fs-14 table-text-color wt-200 pl-15">{transporter.logInTime && moment(transporter.logInTime).format(LOG_IN_AND_LOG_OUT)}</div>
                                        <div className="fs-14 table-text-color wt-200 pl-15">{transporter.logOutTime && moment(transporter.logOutTime).format(LOG_IN_AND_LOG_OUT)}</div>
                                        {/* <div className="fs-14 flex-inline table-text-color wt-200 pl-15" onClick={(e) => { e.preventDefault() }}>
                                            <div className="flex mt--1" onClick={(e) => { e.preventDefault() }}>
                                                <SingleDatePicker
                                                    noBorder={true}
                                                    displayFormat={"DD MMM YYYY"}
                                                    hideKeyboardShortcutsPanel={true}
                                                    placeholder={"Placement date"}
                                                    numberOfMonths={2}
                                                    date={Moment(new Date())} 
                                                    onDateChange={(from) =>{
                                                        const date = from.format('YYYY-MM-DD') + ' ' + Moment(new Date()).format('HH:mm')
                                                        this.setState({ date });
                                                        // props.onToDateChange(new Date(date).getTime());
                                                    }}
                                                    focused={this.state.focused} 
                                                    onFocusChange={({ focused }) => { this.setState({ focused }) }} 
                                                    // isOutsidseRange={(date) => date < new Date().setHours(0)}
                                                />
                                                <TimePicker
                                                    showSecond={false}
                                                    value={Moment(new Date())}
                                                    className="ht-40 wt-150 border-status-bar br-5"
                                                    onChange={(from) =>{
                                                        const date = Moment(new Date()).format('YYYY-MM-DD') + ' ' + from.format('HH:mm')
                                                        // props.onToDateChange(new Date(date).getTime());
                                                    }}
                                                    minTime={new Date()}
                                                    format={'h:mm a'}
                                                    use12Hours
                                                    inputReadOnly
                                                    // disabled={this.viewMode || this.viewType===TRIP_TYPE}
                                                />
                                            </div>
                                        </div> */}
                                    </Link>
                                </Fragment>
                                )
                            })
                        }
                        {!(transporters && transporters.length > 0) && <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Transporter Found</div>}
                    </ResponsiveTable>
                </div>
            </div>

        )
    }
}

export default TransportersTable;
